import React, { useState } from 'react'
import './ProductCard.css'

const ProductCard = ({ initialSoldOut = false }) => {
  const [isSoldOut, setIsSoldOut] = useState(initialSoldOut)

  const cardClassName = `product-card${isSoldOut ? ' product-card--sold-out' : ''}`

  const handleToggleSoldOut = () => {
    setIsSoldOut(!isSoldOut)
  }

  // Calcular percentatge de descompte
  const oldPrice = 149.99
  const currentPrice = 99.99
  const discountPercentage = Math.round(((oldPrice - currentPrice) / oldPrice) * 100)

  return (
    <div className={cardClassName}>
      <div className='product-image'>
        <img src='https://via.placeholder.com/250x350' alt='Producte Genèric' />
      </div>

      <div className='product-info'>
        <h2 className='product-title'>Auriculars Inalàmbrics Pro</h2>
        <p className='product-description'>Cancel·lació de soroll avançada, 30 hores de bateria i so d'alta fidelitat. El disseny ergonòmic garanteix la màxima comoditat.</p>

        {/* AMPLIACIÓ 3: Secció de preus amb etiqueta de descompte */}
        <div className='product-price-section'>
          <div className='price-container'>
            <span className='current-price'>99,99 €</span>
            <span className='old-price'>149,99 €</span>
          </div>

          {/* Separador flexible que empeny l'etiqueta cap a la dreta */}
          <div className='flex-spacer'></div>

          {/* Etiqueta de descompte */}
          <span className='discount-badge'>-{discountPercentage}%</span>
        </div>

        <button className='add-to-cart-btn' disabled={isSoldOut} onClick={handleToggleSoldOut}>
          {isSoldOut ? 'Esgotat' : 'Afegir a la cistella'}
        </button>

        <button
          className='toggle-sold-out-btn'
          onClick={handleToggleSoldOut}
          style={{
            marginTop: '10px',
            padding: '5px',
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '3px',
            cursor: 'pointer',
            fontSize: '0.8em',
          }}
        >
          {isSoldOut ? 'Marcar com disponible' : 'Marcar com esgotat'}
        </button>
      </div>
    </div>
  )
}

export default ProductCard
